/**
 * Tago — first client config.
 * P2P vehicle rental marketplace in El Salvador.
 */
import type { ClientConfig } from '../../lib/client/config.schema'

const config: ClientConfig = {
  brand: {
    name: 'Tago',
    meaning: 'Take & Go',
    tagline: '¡Tu mejor opción para movilizarte en El Salvador!',
    service: 'Leasing y Rent-a-Car',
    version: '0.1.0',
    contact: {
      whatsapp: '+503 7839 2213',
      whatsappLink: 'https://wa.me/50378392213',
      email: 'team@tago.rent',
    },
  },

  colors: {
    primary: { DEFAULT: '#480C82', light: '#6A21B4', dark: '#2B074F' },
    secondary: { DEFAULT: '#F0422D', light: '#FF6A52', dark: '#C72D1D' },
    accent: { DEFAULT: '#FCCF87', light: '#FFE8CC', dark: '#9B5A00' },
    gradient: { start: '#480C82', middle: '#A51640', end: '#F0422D' },
    status: { success: '#22C55E', warning: '#FF9500', error: '#F0422D', info: '#5AC8FA' },
  },

  fonts: {
    heading: 'Heavitas',
    body: 'Montserrat-SemiBold',
    bodyBold: 'Montserrat-Bold',
    mono: 'SpaceMono',
  },

  spacing: { xs: 4, sm: 8, md: 16, lg: 24, xl: 32, '2xl': 48, '3xl': 64 },
  radius: { xs: 2, sm: 8, md: 12, lg: 16, xl: 24, full: 9999 },
}

export default config
